module.exports = __webpack_public_path__ + "static/media/Original Korean Article from - TATHAGATA - message - jayun.0045231e.pdf";